/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

 // You can delete this file if you're not using it

 if (typeof window !== 'undefined') {
  window.onerror = function (message, source, lineno, colno, error) {
    // Optionally log error to a service here
    // eslint-disable-next-line no-console
    console.error('Global error handler:', { message, source, lineno, colno, error });

    // Only reload for the specific 'removeAllEvents' error
    const isRemoveAllEventsError =
      (typeof message === 'string' && message.includes("removeAllEvents")) ||
      (error && error.message && error.message.includes("removeAllEvents"));

    if (isRemoveAllEventsError) {
      window.location.reload();
      return true;
    }

    // For all other errors, just log and let the app continue
    return false;
  };
}